import styled from 'styled-components'

import { InfoBadgeStyled } from '@ui/elements/Badge/styles/InfoBadgeStyled'
import { StatusBadgeStyled } from '@ui/elements/Badge/styles/StatusBadgeStyled'

interface IRadioCardStyledProps {
  isDisabled: boolean
}

export const RadioCardStyled = styled.label<IRadioCardStyledProps>`
  display: block;

  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  padding: ${(props) => props.theme.typography.pxToRem(16)};
  border: 1px solid ${(props) => props.theme.colors.content.border};
  border-radius: ${(props) => props.theme.box.borderRadius(16)};
  background-color: ${(props) => props.theme.colors.contentBackground};

  cursor: pointer;

  input {
    margin: 0 0 0 0;
    accent-color: ${(props) => props.theme.colors.primary};
  }

  &:hover {
    border: 1px solid
      ${(props) => props.theme.colors.form.radioCardGroup.activeBorder};
  }

  &:has(input[type='radio']:checked) {
    border: 1px solid
      ${(props) => props.theme.colors.form.radioCardGroup.activeBorder};
    box-shadow: 0 0 8px ${(props) => props.theme.colors.primary};
  }

  ${InfoBadgeStyled} {
    display: flex;
  }

  ${StatusBadgeStyled} {
    display: flex;
  }

  ${(props) =>
    props.isDisabled &&
    `
    cursor: not-allowed;
    border: 1px solid ${props.theme.colors.form.radioCardGroup.disabledBorder};

    &:hover {
      border: 1px solid ${props.theme.colors.form.radioCardGroup.disabledBorder};
    }

    > * {
      opacity: 0.35;
    }
  `}
`
